import React from "react";
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { Typography, Button } from "@material-ui/core";
import ErrorMessages from "../../ErrorMessages";

const ApmPayButton = ({ currentPaymentSystem, errorString }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <>
            {errorString && (
                <ErrorMessages errorString={errorString} />
            )}
            <Typography align="center" className={classes.error} gutterBottom>
                {currentPaymentSystem?.warningMessage}
            </Typography>
            <Button
                className={classes.submitButton}
                fullWidth
                variant="contained"
                color="secondary"
                size="large"
                type="submit">
                {t('PAY')} {currentPaymentSystem?.amountToPay} {currentPaymentSystem?.currencyToPay}
            </Button>
        </>
    )
}

export default ApmPayButton;